import { Button, notification } from 'ant-design-vue'
import dayjs from 'dayjs'
import { h } from 'vue'
import { useRequest } from 'vue-request'
import type { Router } from 'vue-router'

/**
 * 前端重新部署则提醒刷新页面
 */
export function setupRefreshHook(router: Router) {
  let isNeedRefresh = false
  let prevBuildTime: string

  // 轮询版本
  const { cancel } = useRequest<{ buildTime: string; buildCode: string }>(
    () => `/version.json?t=${Date.now()}`,
    {
      pollingInterval: 60000,
      onSuccess(data) {
        if (prevBuildTime && prevBuildTime !== data.buildTime) {
          isNeedRefresh = true
          cancel()
          notify(data.buildTime, data.buildCode)
        }
        prevBuildTime = data.buildTime
      },
    }
  )

  function notify(time: string, version: string) {
    notification.info({
      duration: 0,
      message: '检测到有更新',
      description: h('span', {
        innerHTML: `网页版本有更新, 为避免影响使用, 请及时刷新页面。<br/> 更新时间: ${dayjs(
          time
        ).format('YY-MM-DD HH:mm')}，版本号: ${version}`,
      }),
      btn: () =>
        h(
          Button,
          {
            type: 'primary',
            onClick: () => location.reload(),
          },
          { default: () => '立即刷新' }
        ),
    })
  }

  // router.beforeEach((to) => {
  //   if (isNeedRefresh) {
  //     isNeedRefresh = false
  //     location.href = to.fullPath
  //   }
  // })
}
